export default "__VITE_ASSET__DQOHyH9r__"